export default __webpack_public_path__ + "static/media/element_70.702c0f19.jpg";